import { StyleSheet } from 'react-native'

import { fontFamily } from '../../theme/fontFamily'

const styles = StyleSheet.create({
  winningHeadingContainer: {
    justifyContent: 'center',
    flexDirection: 'row',
    paddingTop: 20
  },
  winningHeading: {
    textAlign: 'center',
    fontSize: 24,
    color: 'white',
    fontFamily: fontFamily.sfProDisplayHeavyItalic
  },
  separator: {
    height: 1,
    width: '70%',
    backgroundColor: '#C4C4C4',
    marginVertical: 12,
    alignSelf: 'center'
  },
  leaderBoardText: {
    fontSize: 20,
    color: '#FFBB0E',
    fontFamily: fontFamily.sfProDisplayBoldItalic,
    textTransform: 'uppercase',
    textAlign: 'center'
  },
  myDataContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center'
  },
  myDataLabels: {
    fontFamily: fontFamily.sfProDisplayMediumItalic,
    fontSize: 13,
    color: '#6E8DE3'
  },
  myDataValues: {
    fontFamily: fontFamily.sfProDisplayBoldItalic,
    fontSize: 13,
    color: '#fff',
    paddingTop: 5
  },
  tableHeader: {
    height: 30,
    borderBottomWidth: 1,
    borderColor: '#ffffff20',
    borderTopWidth: 1,
    width: '100%',
    flexDirection: 'row',
    marginTop: 16,
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: 16
  },
  raValueContainer: {
    alignItems: 'flex-end',
    paddingHorizontal: 5,
    width: '20%'
  },
  raValue: {
    fontSize: 13,
    fontFamily: fontFamily.sfProDisplayBold
  },
  nameValue: {
    textAlign: 'left',
    fontSize: 14,
    fontFamily: fontFamily.sfProDisplayBold
  },
  stackValue: {
    textAlign: 'center',
    fontSize: 13,
    fontFamily: fontFamily.sfProDisplayBold
  },
  raHeaderContainer: {
    width: '20%',
    alignItems: 'flex-end',
    paddingHorizontal: 5
  },
  raHeading: {
    fontSize: 13,
    fontFamily: fontFamily.sfProDisplayMediumItalic,
    textAlign: 'right'
  },
  nameHeaderContainer: {
    width: '60%',
    // width: '40%',
    paddingHorizontal: 18,
    alignItems: 'flex-start'
  },
  nameHeading: {
    fontSize: 14,
    fontFamily: fontFamily.sfProDisplayHeavyItalic,
    textAlign: 'right'
  },
  stackHeading: {
    fontSize: 14,
    fontFamily: fontFamily.sfProDisplayHeavyItalic,
    textAlign: 'center'
  },
  stackHeaderContainer: {
    width: '25%',
    justifyContent: 'center',
    // alignItems: 'flex-end',
    paddingHorizontal: 5
  },
  rankHeading: {
    fontSize: 14,
    fontFamily: fontFamily.sfProDisplayHeavyItalic,
    textAlign: 'center'
  },
  rankHeaderContainer: {
    width: '18%',
    justifyContent: 'center',
    paddingHorizontal: 5
  },
  totalChipsContainer: {
    borderColor: '#ffffff20',
    borderTopWidth: 1
  },
  totalChipsView: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginTop: 10,
    marginRight: 10
  },
  totalChipsTitle: {
    fontFamily: fontFamily.sfProDisplayHeavyItalic,
    fontSize: 14,
    color: '#6E8DE3'
  },
  totalChipsAmount: {
    fontFamily: fontFamily.sfProDisplayHeavyItalic,
    fontSize: 14,
    color: 'white'
  }
})

export default styles
